import { PlaceMedia } from './get'


export const URL = '/v2/pms/accomodations/:placeId/media/:mediaId/'

export type Req = void

export type Resp = PlaceMedia